import { createFeature, createReducer, on } from '@ngrx/store';

import { CoreMappingsActions } from '../actions/core-mappings.actions';
import { INITIAL_CORE_MAPPINGS_STATE } from '../core-mappings.state';

export const coreMappingsFeatureKey = 'coreMappings';

export const coreMappingsReducer = createReducer(
  INITIAL_CORE_MAPPINGS_STATE,

  on(CoreMappingsActions.loadBuyers, (state) => ({
    ...state,
    buyersStatus: 'loading' as const,
  })),

  on(CoreMappingsActions.loadBuyersSuccess, (state, { buyers }) => ({
    ...state,
    buyers,
    buyersStatus: 'success' as const,
  })),

  on(CoreMappingsActions.loadBuyersFailure, (state) => ({
    ...state,
    buyersStatus: 'error' as const,
  })),

  on(CoreMappingsActions.uploadMappings, (state) => ({
    ...state,
    uploadStatus: 'loading' as const,
    uploadError: null,
  })),

  on(CoreMappingsActions.uploadMappingsSuccess, (state, { message }) => ({
    ...state,
    uploadStatus: 'success' as const,
    uploadSuccessMessage: message,
    uploadError: null,
  })),

  on(CoreMappingsActions.uploadMappingsFailure, (state, { error }) => ({
    ...state,
    uploadStatus: 'error' as const,
    uploadError: error,
  })),

  on(CoreMappingsActions.uploadMappingsReset, (state) => ({
    ...state,
    uploadStatus: 'idle' as const,
    uploadSuccessMessage: null,
    uploadError: null,
  })),

  on(CoreMappingsActions.downloadMappings, (state) => ({
    ...state,
    downloadStatus: 'loading' as const,
    downloadError: null,
  })),

  on(CoreMappingsActions.downloadMappingsSuccess, (state) => ({
    ...state,
    downloadStatus: 'idle' as const,
  })),

  on(CoreMappingsActions.downloadMappingsFailure, (state, { error }) => ({
    ...state,
    downloadStatus: 'error' as const,
    downloadError: error,
  })),

  on(CoreMappingsActions.downloadMappingsReset, (state) => ({
    ...state,
    downloadStatus: 'idle' as const,
    downloadError: null,
  })),
);

export const coreMappingsFeature = createFeature({
  name: coreMappingsFeatureKey,
  reducer: coreMappingsReducer,
});
